import React from 'react';
import { useIntl } from 'react-intl';

import { DecidingCard, DecidingContainer, DecidingFooter, DecidingHeading, DecidingTile } from './styles';

/*
 * Held while the filtered read decides which confirmation the tenant gets. Rendering eagerly shows the
 * full receipt and swaps it a beat later, under someone who has just paid. The wait is bounded in
 * `useBookingAddOnsOffer`, so a hung read falls through rather than stranding anyone here.
 *
 * ⛔ A SKELETON OF THE CONFIRMATION, not a spinner. This modal takes its height from its content, so a
 * centred spinner made the box jump to a taller layout when the read landed. Standing in for the real
 * screen's blocks keeps the height still across the swap — see `DecidingContainer`.
 */
export const ReceiptDeciding = (): JSX.Element => {
  const intl = useIntl();

  /* Polite, not assertive: a progress report should not interrupt a screen reader mid-sentence. */
  return (
    <DecidingContainer data-testid="receipt-deciding" role="status" aria-label={intl.formatMessage({ id: 'loading' })}>
      {/* aria-hidden throughout: the container above already announces the wait, and these are shapes. */}
      <DecidingHeading aria-hidden="true" />
      <DecidingTile aria-hidden="true" />
      <DecidingCard aria-hidden="true" />
      <DecidingFooter aria-hidden="true" />
    </DecidingContainer>
  );
};
